<template>
    <div class="menu-item" @click="goToLink(link)">
        <div class="mi-circle"></div>
        <div class="mi-text">{{text}}</div>
    </div>
</template>

<script>
    import EventBus from "../main";

    export default {
        name: "MenuItem",
        props: ['text','link','callback'],
        methods: {
            goToLink(link) {
                if (link === '#') {
                    EventBus.$emit('menu-status');
                    this.$router.push({name: 'Home'});
                } else if (link.includes('to:')) {
                    EventBus.$emit('menu-status');
                    link.includes('/') ? this.$router.push(link.replace('to:','')) : this.$router.push({name: link.replace('to:','')});
                } else if (link === "_fn") {
                    this['callback']();
                } else {
                    window.open(link);
                }
            }
        }
    }
</script>

<style lang="scss">
    .menu-item {
        display: flex;
        flex-direction: row;
        width: 70%;
        margin: 32px auto;
        align-items: center;
        min-width: 280px;
        cursor: pointer;
        .mi-text {
            text-transform: uppercase;
            font-size: 12px;
        }
        .mi-circle {
            width: 13px;
            height: 13px;
            min-width: 13px;
            min-height: 13px;
            border: 3px solid white;
            border-radius: 13px;
            margin-right: 16px;
        }
    }
</style>
